import { ball, body, coverBg, edge, fade, gearPath, gloss, mix, shade, shadowInk, tint, warm, type ArtPal } from './kit';

/** Workshop: two meshing gears, a warm light bulb and a wrench on the inventor's bench. */
export function workshopCover(P: ArtPal, p: string): string {
  const top = P.dark ? mix(P.bg, P.gold, 0.1) : tint(P.gold, 0.86);
  const mid = P.dark ? mix(P.panel, P.orange, 0.1) : tint(P.orange, 0.9);
  const bottom = P.dark ? mix(P.bg, P.orange, 0.05) : tint(P.gold, 0.9);
  const bg = coverBg(p, P, top, mid, bottom, [440, 190]);
  const bench = P.dark ? mix(P.orange, P.bg, 0.74) : mix(P.orange, '#FFFFFF', 0.62);

  const gear = (cx: number, cy: number, R: number, teeth: number, id: string, c: string, hub: number) =>
    `<path d="${gearPath(cx, cy, R, R * 0.8, teeth)}" fill="url(#${p}${id})" stroke="${edge(c, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<circle cx="${cx}" cy="${cy}" r="${R * 0.62}" fill="none" stroke="${shade(c, 0.2)}" stroke-opacity=".35" stroke-width="3"/>` +
    `<circle cx="${cx}" cy="${cy}" r="${hub}" fill="${P.dark ? P.bg : shade(P.bg, 0.06)}" stroke="${edge(c, P)}" stroke-width="2"/>` +
    `<circle cx="${cx}" cy="${cy}" r="${hub * 0.45}" fill="url(#${p}${id})"/>` +
    gloss(cx - R * 0.38, cy - R * 0.44, R * 0.3, R * 0.1, -38, 0.45);

  const bx = 588;
  const by = 104;
  const bulb =
    `<circle cx="${bx}" cy="${by}" r="84" fill="url(#${p}halo)"/>` +
    `<path d="M${bx} ${by - 50}C${bx + 34} ${by - 50} ${bx + 44} ${by - 10} ${bx + 22} ${by + 14}Q${bx + 16} ${by + 22} ${bx + 16} ${by + 34}H${bx - 16}Q${bx - 16} ${by + 22} ${bx - 22} ${by + 14}C${bx - 44} ${by - 10} ${bx - 34} ${by - 50} ${bx} ${by - 50}Z" fill="url(#${p}bl)" stroke="${edge(P.gold, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<path d="M${bx - 10} ${by + 6}q5 -9 10 0t10 0" fill="none" stroke="${P.orange}" stroke-width="2.6" stroke-linecap="round" stroke-opacity=".85"/>` +
    `<rect x="${bx - 17}" y="${by + 34}" width="34" height="18" rx="4" fill="url(#${p}mt)" stroke="${edge(P.blue, P)}" stroke-width="1.6"/>` +
    `<path d="M${bx - 16} ${by + 41}H${bx + 16}M${bx - 16} ${by + 47}H${bx + 16}" stroke="${edge(P.blue, P)}" stroke-width="1.4" stroke-opacity=".5"/>` +
    gloss(bx - 14, by - 28, 10, 6, -38, 0.7);

  const wrench =
    `<g transform="translate(360 330) rotate(-18)">` +
    `<ellipse cx="6" cy="18" rx="90" ry="8" fill="url(#${p}sh)"/>` +
    `<path d="M-70 -9H48V9H-70Z" fill="url(#${p}wr)" stroke="${edge(P.blue, P)}" stroke-width="2"/>` +
    `<path d="M40 -22C56 -30 76 -24 82 -8L66 -8L60 0L66 8L82 8C76 24 56 30 40 22C34 14 34 -14 40 -22Z" fill="url(#${p}wr)" stroke="${edge(P.blue, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<circle cx="-78" cy="0" r="16" fill="url(#${p}wr)" stroke="${edge(P.blue, P)}" stroke-width="2"/>` +
    `<circle cx="-78" cy="0" r="6" fill="${P.dark ? P.bg : shade(P.bg, 0.06)}"/>` +
    gloss(-20, -4, 36, 2.4, 0, 0.5) +
    `</g>`;

  const defs =
    `<defs>${bg.defs}` +
    fade(`${p}sh`, shadowInk(P), P.dark ? 0.55 : 0.18) +
    body(`${p}bn`, bench, 0.25, 0.3, 0.3, 1) +
    ball(`${p}ga`, warm(P), 0.4, 0.45) +
    ball(`${p}gb`, P.orange, 0.4, 0.45) +
    ball(`${p}bl`, tint(warm(P), 0.35), 0.6, 0.2) +
    fade(`${p}halo`, P.gold, P.dark ? 0.28 : 0.45) +
    body(`${p}mt`, P.blue, 0.35, 0.3, 0.3, 1) +
    body(`${p}wr`, P.dark ? mix(P.blue, P.ink, 0.55) : tint(P.blue, 0.55), 0.45, 0.35, 0.3, 1) +
    `</defs>`;

  return (
    defs +
    bg.body +
    // bench
    `<path d="M170 400L205 318H640V400Z" fill="url(#${p}bn)"/>` +
    `<path d="M205 318H640" stroke="${edge(bench, P)}" stroke-width="3"/>` +
    `<ellipse cx="452" cy="330" rx="140" ry="14" fill="url(#${p}sh)"/>` +
    gear(412, 200, 112, 14, 'ga', warm(P), 30) +
    gear(534, 280, 62, 10, 'gb', P.orange, 17) +
    bulb +
    wrench
  );
}
